// *******************************************************************************
// latest-news filter
// *******************************************************************************
const getActiveCaregoryIds = (allActiveItems) =>
  Array.from(allActiveItems)
    .map((activeItem) => activeItem.getAttribute('data-category'))
    .join('|');

// toggle is-active
const dataFilterLink = document.querySelectorAll('[data-filter-link]');
const allFilterLink = document.querySelector('[data-filter-all]');

const removeActiveClass = (items) => {
  items.forEach((link) => {
    link.classList.remove('is-active');
  });
};

attachEvent('[data-filter-link]', 'click', (ev) => {
  const allBtn = ev.target.getAttribute('data-filter-all');

  if (allBtn) {
    removeActiveClass(dataFilterLink);
    ev.target.classList.add('is-active');
  } else {
    const sectionElem = ev.target.closest('section').classList;

    if (sectionElem.contains('sc-latest-news')) {
      removeActiveClass(dataFilterLink);
      ev.target.classList.add('is-active');
    }

    if (sectionElem.contains('sc-news-list')) {
      ev.target.classList.toggle('is-active');
      const activeItems = document.querySelectorAll('[data-filter-link].is-active');
      allFilterLink.classList.toggle('is-active', activeItems.length === 0);
    }
  }
});

const latestNewsEle = document.querySelector('.latest-news');

if (latestNewsEle) {
  const cmsSelectedCategories = latestNewsEle.getAttribute('data-cms-selected-category');
  const latestNewsInner = latestNewsEle.querySelector('.latest-news__inner');
  const latestNewsFooter = latestNewsEle.querySelector('.latest-news__footer');
  const latestNewsNoPosts = latestNewsEle.querySelector('.latest-news__no-posts');
  const filterAll = latestNewsEle.querySelector('[data-filter-all]');
  let allBtnValue = '';
  if (filterAll) {
    allBtnValue = filterAll.getAttribute('data-filter-all');
  }

  const sendNewsListAjax = async (categoriesId, allBtnValue) => {
    try {
      const response = await axios.post(
        localData.siteURL,
        {
          action: 'getFilteredNewsListPosts',
          id: localData.id,
          categoriesId,
          allBtnValue,
          moduleName: 'latestNews',
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      window.history.replaceState(null, null, response.data.data.pageLink);
      latestNewsInner.innerHTML = response.data.data.posts;
      latestNewsFooter.innerHTML = response.data.data.viewButton;
      latestNewsNoPosts.classList.add('hide');

      if (response.data.data.noPosts) {
        latestNewsNoPosts.classList.remove('hide');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const latestnewsAjax = (allElem) => {
    const allItems = latestNewsEle.querySelectorAll(allElem);
    const categoriesId = getActiveCaregoryIds(allItems);
    sendNewsListAjax(categoriesId || cmsSelectedCategories, categoriesId === '' ? allBtnValue : '');
  };

  attachEvent('.latest-news .category-list__item', 'click', () => {
    latestnewsAjax('.latest-news .category-list__item.is-active');
  });

  // On window load remove view btn and show msg if no any posts
  window.addEventListener('load', () => {
    if (latestNewsInner.innerHTML.trim() === '') {
      latestNewsFooter.innerHTML = '';
      latestNewsNoPosts.classList.remove('hide');
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const filterCategory = urlParams.get('filtered-categories');
      const allText = latestNewsEle.querySelector('[data-all-text]').getAttribute('data-all-text');

      if (filterCategory) {
        latestNewsEle.querySelector('.btn__text').innerHTML = `${allText} ${filterCategory}`;
      }
    }
  });
}
